export const name = 'pdfListService';
export default function pdfListService($log,$q,$http, additionalErrorsTranslatorFactory, pusherChannel, rnPusher, timeConverterFactory, $mdToast, $translate) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let baseUrl='/api/composer-service/v1/composer/pdfs';

    let initDefer = $q.defer();
    let _this = this;

    (function initialize(){
        pusherChannel.getChannelName().then(
            function(channelName){
                let promises = [];

                promises.push(rnPusher.bind(channelName, "PDF_LIST_PENDING_QUOTA_TO_PENDING_CHANGED", function(changedEntryData){
                    _this.onPendingChangedEntry(changedEntryData);
                }));

                promises.push(rnPusher.bind(channelName, "PDF_LIST_REFRESH", function(){
                    _this.onPdfListRefresh();
                }));

                $q.all(promises).then(
                    function(){
                        initDefer.resolve();
                    },function(){
                        initDefer.reject();
                    }
                );
            },
            function(){
                initDefer.reject();
            }
        );
    }());

    let onPdfListRefreshFunction = null;
    this.registerOnPdfListRefreshFunction = function(onPdfListRefreshFunc){
      onPdfListRefreshFunction = onPdfListRefreshFunc;
    };

    this.onPdfListRefresh = function(){
      if(onPdfListRefreshFunction !== null){
        onPdfListRefreshFunction();
      }
    };

    this.onPendingChangedEntry = function(changedEntryData){
      let toastText = '';

      $translate.onReady(()=>{
        switch(changedEntryData.numberOfChangedPdfs){
          case 0:
            toastText = $translate.instant('imposer.composer-main.did_not_find_any_pending_quota_pdfs');
            break;
          case 1:
            toastText = $translate.instant('imposer.composer-main.retrying_pending_quota_pdf');
            break;
          default:
            toastText = $translate.instant('imposer.composer-main.retrying_N_pending_quota_pdfs', [changedEntryData.numberOfChangedPdfs]);
            break;
        }
        $mdToast.show($mdToast.simple().textContent(toastText));
      });
    };

    this.getPage = function(page, pageSize, searchFilter = null, tag = null, statusFilter = null){
        let functionName = 'pdfListService.getPage';
        $log.log(angular.toJson({functionName:functionName, action:'function called',page:page, pageSize:pageSize, searchFilter:searchFilter}));

        let defer = $q.defer();

        let url=baseUrl + '/page?page=' + page + "&page-size=" + pageSize;

        if(searchFilter !== null && searchFilter !== ""){
            url += '&search-filter=' + searchFilter;
        }

        if(statusFilter !== null && statusFilter !== ""){
          url += '&status-filter=' + statusFilter;
        }

        if(tag !== null && tag !== ""){
            url += '&tag=' + tag;
        }

        initDefer.promise.then(
            function(){
                $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
                then(function(pageConrent){
                    _this.convertField(pageConrent.data.composedPdfs, [_this.populatePdfStatuses, _this.timestampToStringDatetime, _this.calculateTimeTookToCompose]);
                    //_this.statusToStatusForDisplay(pageConrent.composedPdfs);
                    defer.resolve(pageConrent.data);
                },function(error){
                    $log.error(angular.toJson({functionName:functionName, action:'fail returning from server', error:error.data, status:error.status}));
                    defer.reject(error.status);
                });
            },
            function(){}
        );
        return defer.promise;
    };

    this.recomposePendingQuota = function() {
      var functionName = 'recomposePendingQuota';
      let url = '/api/composer-service/v1/composer/ecommerce/pending-quota';
      $http({method: 'POST', url: url, headers: {'Accept': 'application/json'}}).then(()=>{},
          error => {
            $log.error(angular.toJson({functionName: functionName, action: 'fail returning from server', error:error.data, status:error.status}));
          });
    };

    this.deleteMany = function(pdfsToDelete){
        var functionName = 'pdfListService.deleteMany';
        $log.log(angular.toJson({functionName:functionName, action:'function called',pdfsToDelete:pdfsToDelete}));
        var defer = $q.defer();

        let url=baseUrl;

        let composedPdfCollection={
          composedPdfs: pdfsToDelete
        };

        $http({method: 'DELETE', data:composedPdfCollection, url: url, headers: {'Content-Type':'application/json'}}).
        then(function(){
            $log.log(angular.toJson({functionName:functionName, action:'return successfully'}));
            defer.resolve();
        },function(error){
            $log.log(angular.toJson({functionName:functionName, action:'failed',error:error.data,status:error.status}));
            defer.reject(error.data);
        });

        return defer.promise;
    };

    this.convertField = function(pdfs, convertFuncs){
        for(let iPdf = 0; iPdf < pdfs.length; iPdf++){
            for(let iConvertFunc = 0; iConvertFunc < convertFuncs.length; iConvertFunc++){
                convertFuncs[iConvertFunc](pdfs[iPdf]);
            }
        }
    };

    this.timestampToStringDatetime = function(pdf){
        if(pdf.startTime === null && pdf.clientTimestamp !== null) {
          pdf.startTime = pdf.clientTimestamp;
        }
        pdf.startTimeDisplay = timeConverterFactory.timestampToLocalizedString(pdf.startTime);
        pdf.endTimeDisplay = timeConverterFactory.timestampToLocalizedString(pdf.endTime);
    };

    this.calculateTimeTookToCompose = function(pdf){
      if(pdf.startTime && pdf.endTime){
        pdf.timeTookToCompose = msToTime(pdf.endTime - pdf.startTime);
      }
    };

    function msToTime(duration) {
      var milliseconds = parseInt((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds;
    }

    // by reference
    this.statusToStatusForDisplay = function(status){
      switch(status){
        case 'inProcess':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_In_Process';
        case 'completed':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_Completed';
        case 'warning':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_Warning';
        case 'error':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_Error';
        case 'pending':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_Waiting';
        case 'pendingQuota':
          return 'imposer.composer-main.Composer_Composed_Pdf_Status_Pending_Quota';
      }
    };

    this.populatePdfStatuses = function(composedPdf){
      if(composedPdf.status === 'completed' && composedPdf.warnings !== undefined && composedPdf.warnings !== null && composedPdf.warnings.length > 0){
        composedPdf.status = 'warning';
      }else if(composedPdf.status === 'error'){
        composedPdf.engineError = additionalErrorsTranslatorFactory.getAdditionalErrorMessage(composedPdf.additionalError, composedPdf.engineError, 'composerPdfCreation');
      }
      composedPdf.statusForDisplay = _this.statusToStatusForDisplay(composedPdf.status);
    };

    this.getPdfDownloadUrls = function(pdfsIdToDownload){
        let functionName = 'pdfListService.getPdfDownloadUrls';
        $log.log(angular.toJson({functionName:functionName, action:'function called',pdfsIdToDownload:pdfsIdToDownload}));

        let defer = $q.defer();

        let url = baseUrl + "/download-urls";
        let composedPdfIdsCollection={pdfIds:pdfsIdToDownload};

        $http({method: 'POST', data: composedPdfIdsCollection, url: url, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
        then(function(composedPdf){
            defer.resolve(composedPdf.data);
        },function(error){
            $log.log(angular.toJson({functionName:functionName, action:'failed',error:error.data,status:error.status}));
            defer.resolve(error.data);
        });

        return defer.promise;
    };

    this.getPdf = function(pdfId){
        let functionName = 'pdfListService.getPdf';
        $log.log(angular.toJson({functionName:functionName, action:'function called',pdfId:pdfId}));

        let defer = $q.defer();

        let url=baseUrl + '/' + pdfId;
        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
        then(function(composedPdf){
            defer.resolve(composedPdf.data.pdfUrl);
        },function(error){
            $log.log(angular.toJson({functionName:functionName, action:'failed',error:error.data,status:error.status}));
            defer.resolve(error.data);
        });

        return defer.promise;
    };

    this.updateTags = function(pdfId, tagsString){
      let functionName = 'pdfListService.updateTags';
      $log.log(angular.toJson({functionName:functionName, action:'function called', pdfId:pdfId}));

      let defer = $q.defer();
      let url = baseUrl + "/" + pdfId + "/tags";
      let data = {
        tags:tagsString
      };

      $http({method: 'PUT', url: url, data: data,  headers: {'Accept':'application/json','Content-Type':'application/json'}}).
      then(function (tags) {
        $log.log(angular.toJson({functionName:functionName, action:'function data return', pdfId:pdfId, tags:tags}));
        defer.resolve(tags.data.tags);
      },function(error) {
        $log.error(angular.toJson({functionName:functionName, action:'function return error', pdfId:pdfId, error:error.data}));
        defer.reject(error.status);
      });
      return defer.promise;
    };
}
